
import { computed, defineComponent, ref } from "vue";
import { useStore } from "vuex";
import { IDonViResponseBase } from "@/core/interfaces/ApiResponses";
import { hasSuperadminRole } from "@/core/helpers/authorization-utils";
import { swalErrNotification } from "@/core/helpers/utils";
import { usePageHeader } from "@/core/hooks/usePageHeader";
import { DonViService } from "@/core/services/DonVi.service";
import { faRefresh, faFileImport } from "@fortawesome/free-solid-svg-icons";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import PageHeaderActions from "@/layout/header/PageHeaderActions.vue";
import PageHeaderActionItem from "@/layout/header/PageHeaderActionItem.vue";
import DongBoKetoanModal from "@/views/crafted/pages/don-vi/DongBoKetoanModal.vue";

export default defineComponent({
  name: "don-vi-list",

  components: {
    PageContentBase,
    PageHeaderActions,
    PageHeaderActionItem,
    DongBoKetoanModal,
  },

  setup() {
    const store = useStore();
    const items = ref<IDonViResponseBase[]>([]);
    const loading = ref(false);
    const isSyncModalOpen = ref(false);

    document.title = "Đơn vị - Đường sắt Hà Nội";

    const actorRoleNames = computed<string[]>(
      () =>
        store.getters.currentUser?.roles?.map(
          (role: { name: string }) => role.name
        ) || []
    );

    const isSuperadmin = computed(() =>
      hasSuperadminRole(actorRoleNames.value)
    );

    const { searchQuery } = usePageHeader({
      title: "Danh sách đơn vị",
      breadcrumbs: [{ text: "Đơn vị" }],
      showSearch: true,
      searchPlaceholder: "Tìm theo mã, tên đơn vị...",
    });

    const filteredItems = computed(() => {
      const term = searchQuery.value.trim().toLowerCase();
      if (!term) {
        return items.value;
      }

      return items.value.filter((item) => {
        const haystack = `${item.ma_don_vi || ""} ${
          item.ten_don_vi || ""
        }`.toLowerCase();
        return haystack.includes(term);
      });
    });

    return {
      items,
      loading,
      searchQuery,
      isSyncModalOpen,
      isSuperadmin,
      filteredItems,
      faRefresh,
      faFileImport,
    };
  },

  async mounted() {
    await this.fetchData();
  },

  methods: {
    formatCapDonVi(cap?: number) {
      if (cap === 1) return "Công ty";
      if (cap === 2) return "Đơn vị";
      return cap != null ? String(cap) : "-";
    },

    async fetchData() {
      this.loading = true;
      try {
        const {
          data: { data },
        } = await DonViService.fetchAllDepartments();
        this.items = Array.isArray(data) ? data : [];
      } catch (error) {
        await swalErrNotification(error, "Có lỗi khi tải danh sách đơn vị");
      } finally {
        this.loading = false;
      }
    },

    async onSyncSuccess() {
      this.isSyncModalOpen = false;
      await this.fetchData();
    },
  },
});
